<!--
 * @Founder: cqb
 * @Description: 
-->
<template>
	<div class="relatedHeader">
		<van-nav-bar :title="title" fixed :z-index="1000" left-text="" :right-text="rightTxt" left-arrow @click-left="onClickLeft(customeLeftClick)"
		 @click-right="onClickRight" />
	</div>
</template>

<script>
	export default {
		props: {
			rightTxt: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: '安全生产信息平台'
			},
			customeLeftClick: {
				type: Number,
				default: 2 // 1 启用自定义配置左键菜单   2 不启用
			},
			flag:{
				type: String,
				default: '',
			},
		},
		// data () {
		//   return {
		//     rightTxt: '按钮'
		//   }
		// },
		methods: {
			onClickLeft(val) {
				if (val === 1) {
					this.$emit('leftBtn')
				} else {
					if(this.flag == 'DHZYYDD'){
						this.$router.push({
							name: this.flag
						})
					}else{
						this.$router.go(-1);
					}
				}
			},
			onClickRight() {
				this.$emit('rightBtn')
			}
		},
		created() {

		}
	}
</script>

<style lang="less">
	.van-nav-bar {
		// background: linear-gradient(45deg, #46b6e9, #05469c);
		height: 1.25rem;
		line-height: 1.25rem;

		.van-nav-bar__title,
		.van-icon,
		.van-nav-bar__content{
			height: 1.25rem;
			color: #fff !important;
			line-height: 1.25rem;
			font-size: 0.45rem;
		}
	}
</style>
